module.exports = __webpack_public_path__ + "static/media/1POLICY35.ab7663aa.jpg";